module.exports = __webpack_public_path__ + "img/agent-query.60dd9080.svg";